<template>
  <v-container
    class="pa-0"
    fluid
  >
    <Statistics
      :application="data.application"
      :offer="data.offer"
      :is-loading="$store.state.loading"
    />
  </v-container>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

import { requests } from '@/mixins/index';

import { applicationStatistics, offerStatistics } from '@/configs/statistics.js';

import Statistics from '@/components/layouts/Statistics.vue';

export default {
  components: { Statistics },
  data () {
    return {
      data: {
        application: null,
        offer: null
      }
    };
  },
  computed: {
    ...mapState(['activeWorkspace']),
    ...mapGetters(['getActiveWorkspaceUuid'])
  },
  watch: {
    activeWorkspace: {
      immediate: true,
      async handler () {
        if (this.activeWorkspace && this.activeWorkspace !== 'spontaneous' && this.$route.name === 'home') {
          this.$store.commit('setLoading', true);

          await this.fetchDashboardData();

          this.$store.commit('setLoading', false);
        }
      }
    }
  },
  methods: {
    fetchOpenSearchStats ({ key }) {
      return requests.searchOpenSearchStatistics({
        key,
        entityUuid: this.getActiveWorkspaceUuid
      });
    },
    async fetchDashboardData () {
      const fieldMapper = (acc, config, stats) => {
        const backendResult = stats.filters.find(f => f.attribute === config.attribute);
        if (backendResult) {
          acc[config.attribute] = { ...config, ...backendResult };
        }
        return acc;
      };

      const [applicationStats, offerStats] = await Promise.all([
        this.fetchOpenSearchStats({ key: 'HOME_APPLICATIONS' }),
        this.fetchOpenSearchStats({ key: 'HOME_OFFERS' })
      ]);

      if (applicationStats?.success) {
        this.data.application = applicationStatistics.reduce((acc, config) => fieldMapper(acc, config, applicationStats), {});
      }

      if (offerStats?.success) {
        this.data.offer = offerStatistics.reduce((acc, config) => fieldMapper(acc, config, offerStats), {});
      }
    }
  }
};
</script>
